import { Text } from "@chakra-ui/react";
import React from "react";
import { MarkdocLink } from "./MarkdocLink";

export function Element({
  label,
  href,
}: {
  label: string;
  href?: string;
}): React.ReactElement {
  const content = (
    <Text as="span" fontWeight="bold">
      {label}
    </Text>
  );

  if (href) {
    return <MarkdocLink href={href}>{content}</MarkdocLink>;
  }

  return content;
}
